<template>
  <div class="confirm_page_box">
    <div class="confirm_order_container">
      <div class="receive_info">

        <!-- 地址信息 start -->
        <div class="receive_info_content">
          <div class="receive_info_title">

            <span>{{ L['收货信息'] }}</span>
            <div class="add_ress" @click="addAddress">
              + {{ L['添加新地址'] }}
            </div>
          </div>
          <div v-if="address_list.data.length" class="address_info_box">
            <div style="width:100%" class="address_con">
              <div class="address_item" :class="{ select_address: current_address_index == index }"
                v-for="(item, index) in exhibition_show? address_list.data:address_list.data.slice(0,3)" :key="index" @click="confirmChangeAddress(index)">
                <div class="address_item_top">
                  <div class="address_item_top_left">

                    <span>{{ item.memberName }}</span>
                    <span>{{ item.telMobile }}</span>
                    <span class="address_tag" v-if="item.isDefault ==1">默认地址</span>
                  </div>
                  <div class="address_item_top_right">
                    <span @click.stop="editAddress(item)">编辑</span>
                    <span @click.stop="delAddress(item.addressId)">删除</span>
                  </div>
                </div>
                <div class="address_item_detail">
                  {{ item.addressAll }} {{ item.detailAddress }}
                </div>
              </div>

            </div>

          </div>

          <div v-if="address_list.data.length" class="exhibition" @click="exhibition">
            {{ exhibition_show ? L['收起全部地址'] : L['查看全部地址'] }}
            <img v-if="exhibition_show" src="../../assets/uparrow.png" alt />
            <img v-else src="../../assets/downarrow.png" alt />
          </div>
          <div v-else class="exhibition_none">{{ L['暂无收货地址'] }}</div>
          <div class="xian">
            <p></p>
          </div>
        </div>
        <!-- 地址信息 end -->

        <!-- 发票信息 start -->
        <div class="invoice_info_box">
          <div class="receive_info_title">
            <span>{{ L['发票信息'] }}</span>
            <div class="add_ress" @click="showInvoiceDialog()">
              {{ L['修改信息'] }}
            </div>
          </div>
          <div class="invoice_info_content">
            <div class="invoice_info_item">
              <div>发票类型</div>
              <div>普通发票</div>
            </div>
            <div class="invoice_info_item">
              <div>发票抬头</div>
              <div>个人</div>
            </div>
          </div>
        </div>
        <!-- 发票信息 end -->

        <div class="goods_box">

          <!-- 店铺 -->
          <div v-for="(storeItem, index) in goods_data.data" :key="index" class="store_item">
            <div class="store_box">
              <div class="receive_info_title">
                <span>{{ L['商品清单'] }}</span>
              </div>
              <div class="goods_container">
                <div class="goods_table_header">
                  <div class="goods_table_goods_info_width">商品名称</div>
                  <div class="goods_table_goods_default_width">单价</div>
                  <div class="goods_table_goods_default_width">数量</div>
                  <div class="goods_table_goods_default_width">合计</div>
                </div>
                <!-- 主商品 -->
                <div v-for="(goodItem, index) in storeItem.productList" :key="index" class="goods_item">
                  <div class="main_goods_item">

                    <div class="main_goods_con goods_table_goods_info_width">
                      <div class="main_goods_img_box">
                        <div class="main_goods_img" :style="{ backgroundImage: 'url(' + goodItem.image + ')' }"></div>
                      </div>
                      <div class="main_goods_info">
                        <div class="main_goods_info_title">{{ goodItem.productShortTitle }}</div>
                        <div class="main_goods_info_pattern">{{ goodItem.specValues?goodItem.specValues:'' }}</div>
                      </div>
                    </div>
                    <div class=" goods_table_goods_default_width">¥{{goodItem.price}}</div>
                    <div class=" goods_table_goods_default_width">x{{ goodItem.buyNum }}</div>
                    <div class=" goods_table_goods_default_width">¥{{goodItem.totalPrice.toFixed(2) }}</div>

                  </div>

                  <!-- 搭配购买 start -->
                  <div class="gift_goods_box" v-if="goodItem.priceIncreasePurchaseList&& goodItem.priceIncreasePurchaseList.length>0">
                    <div class="gift_goods_item" v-for="(val,idx) in goodItem.priceIncreasePurchaseList" :key="idx">
                      <div class="gift_goods_con goods_table_goods_info_width">
                        <div class="gift_goods_title">{{idx==0?'搭配':''}}</div>
                        <div class="gift_goods_info">
                          <div class="gift_goods_img_box">
                            <div class="gift_goods_img" :style="{ backgroundImage: 'url(' + val.image + ')' }"></div>
                          </div>
                          <div class="gift_goods_title_box">
                            <div class="gift_goods_title">{{ val.productShortTitle }}</div>
                            <div class="gift_goods_pattern">{{ val.specValues?val.specValues:'' }}</div>
                          </div>
                          <!-- 定金订单可选增值服务 -->
                          <div v-if="allData.data.presellInfo">
                            <div class="gift_goods_btn" v-if="val.isAvailable" @click="showMatchModal(goodItem)"> 重选 </div>
                            <div class="gift_goods_btn" v-else @click="delProduct(val)"> 删除 </div>
                          </div>
                        </div>
                      </div>
                      <div class=" goods_table_goods_default_width">¥{{ val.price }}</div>
                      <div class=" goods_table_goods_default_width">x{{ val.buyNum }}</div>
                      <div class=" goods_table_goods_default_width">¥{{ val.totalPrice.toFixed(2)  }}</div>
                    </div>
                  </div>
                  <!-- 搭配购买 end -->

                  <!-- 增值服务 start -->
                  <div class="gift_goods_box" v-if="goodItem.incrementList && goodItem.incrementList.length>0">
                    <div v-for="(incrementVal,incrementIdx) in goodItem.incrementList" :key="incrementIdx">

                      <div class="gift_goods_item " :class="{can_delete:!incrementVal.isAvailable}">
                        <div class="gift_goods_con goods_table_goods_info_width">
                          <div class="gift_goods_title">{{incrementIdx==0?'服务':''}}</div>
                          <div class="gift_goods_info">
                            <div class="gift_goods_img_box">
                              <div class="gift_goods_img" :style="{ backgroundImage: 'url(' + incrementVal.image + ')' }"></div>
                            </div>
                            <div class="gift_goods_title_box">
                              <div class="gift_goods_title">{{ incrementVal.productShortTitle }}</div>
                            </div>

                            <!-- 定金订单可选增值服务 -->
                            <div v-if="allData.data.presellInfo">
                              <div class="gift_goods_btn" v-if="incrementVal.isAvailable" @click="showService(goodItem)"> 重选 </div>
                              <div class="gift_goods_btn" v-else @click="delProduct(incrementVal)"> 删除 </div>
                            </div>
                          </div>
                        </div>
                        <div class=" goods_table_goods_default_width">¥{{ incrementVal.price }}</div>
                        <div class=" goods_table_goods_default_width">x{{ incrementVal.buyNum }}</div>
                        <div class=" goods_table_goods_default_width">¥{{ incrementVal.totalPrice.toFixed(2) }}</div>
                      </div>
                    </div>
                  </div>
                  <!-- 增值服务 end -->

                  <!-- 赠品 start -->
                  <div class="gift_goods_box" v-if="goodItem.giftList">
                    <div class="gift_goods_item" v-for="(giftVal,giftIdx) in goodItem.giftList" :key="giftIdx">
                      <div class="gift_goods_con goods_table_goods_info_width">
                        <div class="gift_goods_title">{{giftIdx==0?'赠品':''}}</div>
                        <div class="gift_goods_info">
                          <div class="gift_goods_img_box">
                            <div class="gift_goods_img" :style="{ backgroundImage: 'url(' + giftVal.image + ')' }"></div>
                          </div>
                          <div class="gift_goods_title_box">
                            <div class="gift_goods_title">{{ giftVal.productShortTitle }}</div>
                          </div>

                        </div>
                      </div>
                      <div class=" goods_table_goods_default_width">¥0.00</div>
                      <div class=" goods_table_goods_default_width">x{{ giftVal.buyNum }}</div>
                      <div class=" goods_table_goods_default_width">¥0.00</div>
                    </div>
                  </div>
                  <!-- 赠品 end -->

                  <!-- 选择 搭配 服务 start -->
                  <div class="gift_add_box" v-if="allData.data.presellInfo&&(!goodItem.incrementList||goodItem.incrementList.length==0)">
                    <div class="gift_add_title">服务</div>
                    <div class="gift_add_btn" @click="showService(goodItem)">选择增值服务</div>
                  </div>
                  <!-- 选择 搭配 服务 end -->
                  <!-- 选择加价购 start -->
                  <div class="gift_add_box"
                    v-if="allData.data.presellInfo&&(!goodItem.priceIncreasePurchaseList||goodItem.priceIncreasePurchaseList.length==0)">
                    <div class="gift_add_title">搭配</div>
                    <div class="gift_add_btn" @click="showMatchModal(goodItem)">选择搭配商品</div>
                  </div>
                  <!-- 选择加价购 end -->

                  <!-- 定金状态 start -->
                  <div class="deposit_status_box" v-if="allData.data.presellInfo">
                    <div class="deposit_status_info">
                      <div class="earnest_box " :class="{active_deposit:!allData.data.presellInfo.secondPayState}">
                        <div class="earnest_con"><span class="deposit_tag"></span>定金 ¥{{allData.data.presellInfo.firstMoney}}</div>
                        <div class="earnest_extra" v-if="allData.data.presellInfo.balancePayType==1">定金可抵¥{{allData.data.presellInfo.depositInflation}}</div>
                        <div class="earnest_extra" v-if="allData.data.presellInfo.balancePayType==2">尾款立减¥{{allData.data.presellInfo.discountFinalPayment}}
                        </div>
                      </div>
                      <div class="deposit_ling active_deposit_ling" :class="{'active_deposit_ling':!allData.data.presellInfo.secondPayState}"></div>

                      <div class="earnest_box" :class="{active_deposit: allData.data.presellInfo.secondPayState}">
                        <div class="earnest_con"><span class="deposit_tag"></span>尾款 ¥{{allData.data.presellInfo.secondMoney}}</div>
                        <div class="earnest_extra">{{allData.data.presellInfo.remainStartTime}}～{{allData.data.presellInfo.remainEndTime}}可支付</div>
                      </div>
                    </div>
                  </div>
                  <!-- 定金状态 end -->

                </div>

              </div>

            </div>

            <!-- 优惠券 -->
            <div class="coupon_box_div">
              <div class="coupon_box_div_title">
                <span>{{ L['使用优惠券'] }}</span>
                <div class="convertible_box">
                  <el-input v-model="couponText" style="width: 240px;height:40px" placeholder="请输入兑换码" />
                  <div class="convertible_button" @click="redeemCoupons">兑换</div>
                </div>
              </div>

              <div class="coupon_use_box">
                <div class="coupon_tabs_box">
                  <div class="coupon_tabs_item" :class="{coupon_tabs_active:currentCouponTabs==1}" @click="changeCouponTabs(1)">可用优惠券
                    {{storeItem.availableCouponList.length?storeItem.availableCouponList.length:0}}
                  </div>
                  <div class="coupon_tabs_item" :class="{coupon_tabs_active:currentCouponTabs==2}" @click="changeCouponTabs(2)">不可用优惠券
                    {{storeItem.disabledCouponList.length?storeItem.disabledCouponList.length:0}}</div>
                </div>

                <div class="coupon_use_box_con" v-if="currentCouponTabs==1" :class="{coupon_use_box_con_empty:storeItem.availableCouponList.length==0}">
                  <div v-if="storeItem.availableCouponList.length > 0">
                    <div class="have_coupon">

                      <div class="coupon_item" v-for="val in storeItem.availableCouponList" :key="val.couponMemberId">
                        <div class="coupon_con">
                          <div class="coupon_item_header">
                            <div class="coupon_price" v-if="val.couponType==1">
                              <span class="coupon_price_renminbi">¥</span>
                              <span>{{val.value}}</span>
                            </div>
                            <div class="coupon_price" v-if="val.couponType==2">
                              <span>{{val.value}}</span>
                              <span class="coupon_price_renminbi">折</span>
                            </div>
                            <div class="coupon_tag" v-if="val.content">{{ val.content }}</div>
                          </div>
                          <div class="coupon_title">{{val.couponName}}</div>
                          <div class="coupon_time">有效期：{{val.useTime}}</div>

                        </div>
                        <div class="coupon_item_btn" @click="changeCoupon(storeItem, val)" :class="{coupon_item_btn_checked:val.checked}"></div>
                      </div>
                    </div>
                  </div>
                  <div class="empty_coupon" v-else>
                    <div class="empty_coupon_img"></div>
                  </div>

                </div>
                <div class="coupon_use_box_con" v-if="currentCouponTabs==2" :class="{coupon_use_box_con_empty:storeItem.disabledCouponList.length == 0}">
                  <div v-if="storeItem.disabledCouponList.length > 0">
                    <div class="have_coupon">
                      <div class="coupon_item disabled_coupon" v-for="val in storeItem.disabledCouponList" :key="val.couponMemberId">
                        <div class="coupon_con">
                          <div class="coupon_item_header">
                            <div class="coupon_price" v-if="val.couponType==1">
                              <span class="coupon_price_renminbi">¥</span>
                              <span>{{val.value}}</span>
                            </div>
                            <div class="coupon_price" v-if="val.couponType==2">
                              <span>{{val.value}}</span>
                              <span class="coupon_price_renminbi">折</span>
                            </div>
                            <div class="coupon_tag" v-if="val.content">{{ val.content }}</div>
                          </div>
                          <div class="coupon_title">{{val.couponName}}</div>
                          <div class="coupon_time">有效期：{{val.useTime}}</div>
                        </div>
                        <div class="coupon_item_btn"></div>
                      </div>
                    </div>
                  </div>

                  <div class="empty_coupon" v-else>
                    <div class="empty_coupon_img"></div>
                  </div>
                </div>
              </div>

              <!-- 积分抵扣 支付定金时不能使用积分 -->
              <div v-if="!allData.data.presellInfo || (allData.data.presellInfo&&allData.data.presellInfo.firstPayState)">
                <div class="dividing_line_box">
                  <div class="dividing_line"></div>
                </div>

                <div class="coupon_box_div_title">
                  <span>{{ L['使用积分抵扣'] }}</span>
                </div>

                <!-- 无积分或不可使用积分禁用状态 -->
                <div class="points_use_box">
                  <div class="points_use_con">
                    <div class="points_use_check_btn" @click="changePoints()" :class="{points_use_disabled:!allData.data.isUsePoint||!allData.data.memberIntegral,
                    points_use_checked:allData.data.integral
                    }"></div>
                    <div class="points_use_msg">
                      <div class="points_use_mes_title">
                        <span v-if="allData.data.isUsePoint">使用{{ allData.data.integralCanUse }}积分，<span
                            class="points_use_mes_red">抵¥{{allData.data.integralCanUseCashAmount}}</span></span>
                        <span v-else>本单不可抵扣积分</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <!-- 结算信息 start -->
            <div class="account_box">
              <div class="account_box_title">
                <div>
                  <span>{{ L['结算信息'] }}</span>
                  <span class="account_title_tip"
                    v-if="!allData.data.presellInfo || (allData.data.presellInfo&&allData.data.presellInfo.firstPayState)">{{ L['已按最优方案结算'] }}</span>
                </div>
                <div class="account_title_tip" v-if="allData.data.noReasonReturn">
                  支持7天无理由退货(笔记本Windows激活后不支持，详情参考商品详情页)
                </div>
              </div>
              <div class="account_box_content">
                <div class="remark_box">
                  <!-- 仅needInputSn=1 才显示 -->
                  <el-input v-if="allData.data.needInputSn" class="remark_sn" maxlength="15" v-model="productSn" :placeholder="L['填写15字以内的SN码(必填)']"
                    show-word-limit resize="none" />
                  <el-input maxlength="300" v-model="storeItem.remark" type="textarea" :placeholder="L['填写订单备注']" show-word-limit resize="none" rows="3" />
                </div>

                <!-- 支付信息 -->
                <div class="bill_box">

                  <template v-if="allData.data.presellInfo&&!allData.data.presellInfo.firstPayState">
                    <div class="bill_item" style="margin-bottom:9px">
                      <div class="bill_item_label">定金：</div>
                      <div class="bill_item_value">¥ {{ formatNumberWithCommas(allData.data.totalAmount) }}</div>
                    </div>
                  </template>
                  <template v-else>

                    <div class="bill_item">
                      <div class="bill_item_label">商品总价：</div>
                      <div class="bill_item_value">¥ {{ formatNumberWithCommas(allData.data.totalAmount) }}</div>
                    </div>
                    <div class="bill_item">
                      <div class="bill_item_label">运费金额：</div>
                      <div class="bill_item_value">¥{{storeItem.expressFee}}</div>
                    </div>
                    <div class="bill_item">
                      <div class="bill_item_label">优惠券抵扣：</div>
                      <div class="bill_item_value">-¥{{allData.data.couponDiscountAmount||'0.00'}}</div>
                    </div>
                    <div class="bill_item" v-if="pre_params.data.promotionType == 404">
                      <div class="bill_item_label">A码优惠：</div>
                      <div class="bill_item_value">-¥0.00</div>
                    </div>
                    <div class="bill_item">
                      <div class="bill_item_label">积分抵扣：</div>
                      <div class="bill_item_value">-¥{{ allData.data.integralCashAmount?allData.data.integralCashAmount : 0.00}}</div>
                    </div>
                  </template>

                  <div class="bill_line"> </div>
                  <div class="bill_total">
                    <div class="bill_total_item">
                      <div class="bill_total_item_label">{{ L['支付总额'] }}：</div>
                      <div class="bill_total_item_value">¥ {{ formatNumberWithCommas(allData.data.totalAmount) }}</div>
                    </div>
                    <div class="bill_total_points" v-if="allData.data.presellInfo&&!allData.data.presellInfo.firstPayState">
                      如有可用券，可在尾款时使用
                    </div>
                    <div class="bill_total_points" v-else>
                      可获积分：{{allData.data.sendIntegral}}
                    </div>
                  </div>

                  <div class="bill_line"> </div>

                  <div class="bill_pay_btn_box">
                    <!-- <div class="pay_btn" @click="goCart">返回购物车</div> -->
                    <div class="pay_btn pay_primary" @click="checkOrder">提交订单</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 结算信息 end -->

          </div>

        </div>

      </div>

      <!-- 发票选择——编辑 start -->
      <el-dialog :title="''" v-model="edit_invoice_dialog" destroy-on-close :width="734" @close="closeInvoiceDialog" customClass="invoice_modal_box"
        :before-close="handleClose" lock-scroll="false">
        <div class="invoice_box">
          <div class="invoice_title">{{L['发票信息']}}</div>

          <div class="invoice_content">
            <el-form :model="invoice_info.data" :rules="rules" ref="invoiceForm">

              <el-form-item :label="L['发票类型：']" :label-width="200" prop="invoiceId">
                <el-radio-group v-model="invoice_info.data.invoiceId">
                  <el-radio v-for="invoice_item in invoice_list.data" :label="invoice_item.invoiceId"
                    :key="invoice_item.invoiceId">{{invoice_item.invoiceName}}</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item :label="L['发票抬头：']" :label-width="200" prop="invoiceTitle"
                v-if="invoice_info.data.invoiceId == 'a'||invoice_info.data.invoiceId == 'b'">
                <el-input v-model="invoice_info.data.invoiceTitle" autocomplete="off" :placeholder="L['请填写发票抬头']" clearable></el-input>
              </el-form-item>
              <el-form-item :label="L['纳税人识别号：']" :label-width="200" prop="taxCode" v-if="invoice_info.data.invoiceId == 'b'">
                <el-input v-model="invoice_info.data.taxCode" autocomplete="off" :placeholder="L['请填写纳税人识别号']" clearable></el-input>
              </el-form-item>

            </el-form>

          </div>
          <div class="invoice_btn_box">
            <div @click="confirmInvoice" class="invoice_btn">{{L['确定']}}</div>

          </div>
        </div>
      </el-dialog>
      <!-- 发票选择——编辑 end -->

      <!-- 商品无货缺货弹窗 start -->
      <el-dialog :title="no_good_info.data.stateValue" v-model="out_stock_dialog" customClass="out_store_width" :before-close="handleClose" lock-sroll="false">
        <div class="out_stock_dialog">
          <div v-for="(outStockItem, index) in no_good_info.data.productList" :key="index" class="good_item flex">
            <img :src="outStockItem.image" alt />
            <div class="good_info">
              <span class="good_name overflow_ellipsis">
                {{
                outStockItem.goodsName
                }}
              </span>
              <div class="spec_num">
                <span class="good_spec">{{ outStockItem.specValues }}</span>
                <span class="good_num">*{{ outStockItem.buyNum }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="btn_con flex_row_center_center" v-if="no_good_info.data.state == 2 || no_good_info.data.state == 4">
          <div class="return" @click="returnLastPage">{{ L['返回'] }}</div>
          <div class="remove" @click="clearFailureGoods">{{ L['移除无货商品'] }}</div>
        </div>
        <div class="btn_con flex_row_center_center" v-if="no_good_info.data.state == 7">
          <div class="return" @click="returnLastPage">{{ L['返回'] }}</div>
          <div class="remove" @click="goNext">{{ L['继续下单'] }}</div>
        </div>
        <div class="btn_con flex_row_center_center" v-else>
          <div class="return red" @click="returnLastPage">{{ L['返回'] }}</div>
        </div>
      </el-dialog>
      <!-- 商品无货缺货弹窗 end -->

      <!-- 积分抵扣弹框 -->
      <el-dialog :title="L['使用积分']" v-model="showIntList" width="550px" lock-scroll="false" top="9%">
        <div class="integral_avalible_order">
          <span>{{ L['可用积分'] }}</span>:
          <span>{{ allData.data.memberIntegral }}{{ L['积分'] }}</span>
        </div>
        <div class="use_integral_list_order">
          <div class="integral_item_order" v-for="(item, integralIndex) in allData.data.integralList" :key="integralIndex" @click="tmpInt = item">
            <span>
              {{ L['抵扣'] }}
              <span style="color:var(--color_vice)">¥{{ item / allData.data.integralScale }}</span>
              {{ L['使用'] }}
              <span style="color:var(--color_vice)">{{ item }}</span>
              {{ L['积分'] }}
            </span>
            <div>
              <input type="radio" :value="item" :id="integralIndex" name="integral" :checked="tmpInt == item" />
              <label :for="integralIndex" class="integralLabel_order">
                <div class="img_order"></div>
                <dynaIcon src="buy/sel.png" width="18" height="18" color="--color_vice" class="dyna_icon"></dynaIcon>
              </label>
            </div>
            <div class="no_avalible_order" v-if="item > allData.data.memberIntegral"></div>
          </div>
        </div>
        <div class="integral_btn_order">
          <button class="integral_abandom_order" @click="integralAban">{{ L['暂不使用积分'] }}</button>
          <button class="integral_engage_order" @click="integralEng">{{ L['使用'] }}</button>
        </div>
      </el-dialog>
      <!-- 积分规则框 -->
      <el-dialog :title="L['使用规则']" v-model="showIntRule" width="390px" lock-scroll="false" top="10%">
        <div class="intRule_con">
          <div class="int_rule_item">
            {{
            L['订单大于等于']
            }}
            <font color="var(--color_main)">{{ intRuleList[1] }}{{ L['元'] }}</font>
            {{ L['可用'] }};
          </div>
          <div class="int_rule_item">
            {{
            L['积分支付不超过订单金额的']
            }}
            <font color="var(--color_main)">{{ intRuleList[2] }}%</font>
            ;
          </div>
          <div class="int_rule_item">
            {{
            L['积分使用数量为']
            }}
            <font color="var(--color_main)">{{ intRuleList[0] }}</font>
            {{ L['的整数倍'] }}({{ intRuleList[0] }}{{
            L['积分等于']
            }}
            <font color="var(--color_main)">1{{ L['元'] }}</font>);
          </div>
        </div>
      </el-dialog>
      <!-- 增值服务弹窗 start -->
      <el-dialog :title="''" :width="950" v-model="showServiceModal" customClass="select_service_box" lock-sroll="false">
        <template #title>
          <div class="dialog_title">{{L['增值服务']}}</div>
        </template>
        <div class="service_box">
          <div class="serves_one_level_con">
            <div class="serves_one_level_item" v-for="(interestItem,interestIndex) in incrServiceInfo" :key='interestIndex'>
              <div class="serves_header">
                <div class="serves_header_title">{{interestItem.increaseGroupName}}</div>
                <div class="serves_header_btn" v-if="interestItem.selectedChildKey != -1" @click="goProductDetail(interestItem)">了解服务详情 {{'>'}}</div>
              </div>
              <div class="serves_two_level_con">
                <div class="serves_two_level_item" v-for="(interestValue ,interestKey) in interestItem.commodityList" :key="interestKey"
                  :class="{active_service:interestItem.selectedChildKey == interestKey}"
                  @click="chooseIncreaseService(interestIndex, interestKey, interestValue)">
                  <div class="serves_two_level_item_name">{{interestValue.productShortTitle}}</div>
                  <div class="serves_two_level_item_price"> ¥{{interestValue.productActivityPrice}} </div>
                  <div class="serves_two_level_item_line_text"> ¥{{interestValue.productPrice}} </div>
                  <div class="serves_tag" v-if="interestValue.interestPoint">{{interestValue.interestPoint}} </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="confirm_cancel_btn_box">
          <div class="confirm_cancel_btn" :class="{confirm_cancel_btn_opacity:false}" @click="confirmIncreaseService()">{{ L['确定'] }}</div>
        </div>
      </el-dialog>
      <!-- 增值服务弹窗 end -->
      <!-- 加价购 start -->
      <el-dialog :title="''" :width="812" v-model="showMarkupModal" customClass="select_markup_box" lock-sroll="false">
        <template #title>
          <div class="dialog_title">{{L['推荐搭配']}}</div>
        </template>
        <div class="markup_box">
          <div class="markup_title">推荐搭配</div>
          <div class="markup_content">
            <div class="markup_item" v-for="(val,idx) in priceIncreasePurchaseInfo" :key="idx">
              <div class="markup_item_product">
                <div class="markup_item_product_img">
                  <img :src="val.mainImageUrl">
                </div>
                <div class="markup_product_right">
                  <div class="markup_product_name">{{val.productShortTitle}}</div>
                  <div class="markup_product_price">¥{{val.productIncreasePrice.toFixed(2)}}
                    <div v-if="val.savePrice" class="markup_product_tag"><img src="../../assets/order/sheng.png" alt=""> ¥{{val.savePrice}}</div>
                  </div>
                  <div class="markup_product_line_price">¥{{val.productPrice.toFixed(2)}}</div>

                  <div class="markup_product_check" @click="choosePriceIncreasePurchase(idx)" :class="{markup_product_check_active:val.selected}"></div>
                </div>
              </div>
              <div class="markup_item_quantity_box" v-if="val.selected">
                <div class="markup_quantity_text">请确认数量</div>
                <div class="markup_quantity_operate">
                  <div class="markup_quantity_btn" @click="modifiProductQuantities('diminish',idx)">-</div>
                  <div class="markup_quantity_btn_show">{{ val.buyNum }}</div>
                  <!-- shoppingUpperLimit  最大购买数量 -->
                  <div class="markup_quantity_btn" @click="modifiProductQuantities('plus',idx)">+</div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="confirm_cancel_btn_box">
          <div class="confirm_cancel_btn" :class="{confirm_cancel_btn_opacity:false}" @click="confirmPriceIncreasePurchase()">{{ L['确定'] }}</div>
        </div>
      </el-dialog>
      <!-- 加价购 end -->

      <!-- 定金提醒 start -->
      <el-dialog v-model="frontMoneyFlag" title="" width="414px" customClass="front_money_modal" :close-on-click-modal="false">
        <div class="front_money_box">
          <div class="front_money_title">提醒</div>
          <div class="front_money_content">预售商品定金不支持退款，同意后可继续下单。</div>
          <div class="front_money_btn_box">
            <div @click="frontMoneyFun(2)">我再想想</div>
            <div @click="frontMoneyFun(1)">同意下单</div>
          </div>
        </div>

      </el-dialog>
      <!-- 定金提醒 end -->

      <SldAddressOperation v-if="addressVisibleFlag" :addressInfo="addressInfo" @close="close" @refreshAddress="refreshAddress" :visibleFlag="true"
        :type="type" />
    </div>
  </div>
</template>

<script>
import {
  reactive,
  getCurrentInstance,
  ref,
  onMounted,
  onUnmounted,
  watch,
  computed
} from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import { useStore } from 'vuex'
import SldAddressOperation from '../../components/AddressOperation'
export default {
  name: 'ConfirmOrder',
  components: {
    SldAddressOperation
  },
  setup () {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const addressVisibleFlag = ref(false)
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()
    const not_select = require('../../assets/buy/not_select.png')
    const selected = require('../../assets/buy/selected.png')
    const invoice_selected = require('../../assets/buy/invoice_selected.png')
    const couponCode = ref([])
    const platformCouponCode = ref('')
    const navlist = reactive({ data: [] })
    const show_change_address = ref(false)
    const edit_invoice_dialog = ref(false)
    const out_stock_dialog = ref(false)
    const exhibition_show = ref(false) //地址展开收起
    const favourable_show = ref(0) //选择优惠券和积分
    const default_plat_coupo = reactive({ data: {} }) //选择优惠券和积分
    const previous_page = ref(false)
    const next_page = ref(false)
    const rise = ref(1) //优惠券起始
    const end = ref(8) //优惠券结束
    const total = ref(0) //优惠券结束
    const pagesize = ref(1) //优惠券结束
    const type = ref('add')
    const timer = ref(0) //定时器
    const no_good_info = reactive({ data: {} })
    const show_select_address = ref(false)
    const pre_params = reactive({ data: {} })
    const orderAddress = reactive({ data: '' })
    const address_list = reactive({ data: [] })
    const goods_data = reactive({ data: [] })
    const configInfo = ref(store.state.configInfo)
    const current_address_index = ref(0)

    const addressInfo = reactive({ data: {} })

    const frontMoneyFlag = ref(false); // 定金不退款提醒
    const isAssentFrontMoney = ref(false);// 是否同意定金不退

    const invoiceForm = ref(null);  // 发票form

    const rules = {
      invoiceId: [
        { required: true, message: L["请选择"], trigger: "blur" },
      ],
      invoiceTitle: [
        { required: true, message: L["请输入"], trigger: "blur" },
      ],
      taxCode: [
        { required: true, message: L["请输入"], trigger: "blur" },
      ]
    }; //输入校验
    const invoice_info = reactive({
      data: {
        invoiceId: 'a',//发票ID 增值税专用发票时传入
        invoiceTitle: '',// 发票抬头
        taxCode: '',//税号
        invoiceName: '电子发票-个人', // Name 
        titleType: 1, // 抬头类型 ：1-个人；2-公司(非增值税发票传入)
      }
    })
    const invoice_list = reactive({
      data: [
        {
          invoiceId: 'a',//发票ID 增值税专用发票时传入
          invoiceTitle: '',// 发票抬头
          taxCode: '',//税号
          invoiceName: '电子发票-个人', // Name 
          titleType: 1, // 抬头类型 ：1-个人；2-公司(非增值税发票传入)
        },
        {
          invoiceId: 'b',//发票ID 增值税专用发票时传入
          invoiceTitle: '',// 发票抬头
          taxCode: '',//税号
          invoiceName: '电子发票-公司', // Name 
          titleType: 2, // 抬头类型 ：1-个人；2-公司(非增值税发票传入)
        },
      ]
    }) //发票列表

    // 选中的发票数据
    const select_invoice_info = reactive({
      data: {
        invoiceId: 'a',//发票ID 增值税专用发票时传入
        invoiceTitle: '',// 发票抬头
        taxCode: '',//税号
        invoiceName: '电子发票-个人', // Name 
        titleType: 1, // 抬头类型 ：1-个人；2-公司(非增值税发票传入)
      }
    })
    const selCouponStore = reactive({
      store: {},
      couponCode: ''
    })

    const intRuleList = ref([])
    const invoiceCheckState = ref(true)


    const order_settle_info = reactive({
      totalAmount: '',
      totalDiscount: '',
      platformCouponList: [],
      platformCouponCode: ''
    })
    const allData = reactive({ data: {} })
    const showIntList = ref(false)
    const showIntRule = ref(false)
    const chosenInt = ref(0)
    const tmpInt = ref(0)
    const virtual = reactive({
      isVG: null,
      virtualPre: []
    })
    const orderSn = ref(null) // 是否尾款订单

    const showServiceModal = ref(false) // 全部增值服务数据
    const incrServiceInfo = ref([]) // 全部增值服务数据
    const incrementList = ref([]) // 已选增值服务
    const showMarkupModal = ref(false)
    const priceIncreasePurchaseInfo = ref([]) // 全部加价购数据
    const priceIncreasePurchaseList = ref([]) // 已选加价购

    const currentMainProduct = ref({}) // 当前选中的主商品

    const couponText = ref('') // 兑换优惠券码

    const currentCouponTabs = ref(1); // 优惠券 tabs key


    let canExecute = true; // 控制是否允许执行
    const usePoints = ref(false); // 是否使用积分
    // 节流函数，确保func在wait毫秒内只执行第一次
    const throttle = (func, wait) => {
      let timeout;
      return (...args) => {
        if (canExecute) {
          func(...args); // 直接调用函数并传入参数
          canExecute = false;
          timeout = setTimeout(() => {
            canExecute = true;
            clearTimeout(timeout); // 清除定时器，避免内存泄漏
          }, wait);
        }
      };
    };
    const changePointsFun = () => { // 点击选中积分
      if (!allData.data.isUsePoint || !allData.data.memberIntegral) { // 禁止使用积分状态 或无积分 无法使用
        return;
      }
      usePoints.value = !usePoints.value;
      confirmOrder(2); // 重新获取
    }
    const changePoints = throttle(changePointsFun, 1000);

    const productSn = ref('')


    const discountPlaform = computed(() => {
      let storeDiscounts = goods_data.data
        .map(i => Number(i.totalDiscount))
        .reduce((total, prev) => {
          return total + prev
        }, 0)

      return Number(allData.data.totalDiscount) - storeDiscounts
    })

    const preMsgErr = reactive({
      index: null,
      errMsg: ''
    })
    const isPreventClick = ref(false)
    const reserveInfoList = ref([])

    // 修改优惠券 
    const changeCoupon = (storeItem, couponItem) => {

      if (couponItem.couponCode == selCouponStore.couponCode) {
        console.log("重复选择")
        let coupon = storeItem.availableCouponList.find(item => item.couponCode == selCouponStore.couponCode);
        if (coupon) {

          coupon.checked = false;
        }
        selCouponStore.couponCode = L['不使用优惠券'];
        storeItem.couponCode = L['不使用优惠券'];


        confirmOrder(2)
        return;
      }

      // 单选，清空其它优惠券的已选中
      storeItem.availableCouponList.forEach((item) => {
        item.checked = false;
      })

      let coupon = storeItem.availableCouponList.find(item => item.couponCode == couponItem.couponCode);
      if (coupon) {
        coupon.checked = true;
      }


      selCouponStore.store = storeItem
      selCouponStore.couponCode = couponItem.couponCode


      // return;
      confirmOrder(2)
    }

    /** 兑换优惠券 */
    const redeemCoupons = () => {
      if (isPreventClick.value) {
        return
      }
      isPreventClick.value = true
      let param = {
        couponCode: couponText.value,
      }
      let url = 'v3/promotion/front/coupon/receiveCouponCode';


      proxy
        .$post(url, param, 'application/json')
        .then(res => {
          if (res.state == 200) {

            console.log("操作成功")

            ElMessage.success(res.msg)
            couponText.value = '';
            setTimeout(() => {

              isPreventClick.value = false
            }, 1000)

            confirmOrder(2); // 重新获取
          } else {
            ElMessage.error(res.msg)
            setTimeout(() => {

              isPreventClick.value = false
            }, 1000)
          }

        })



    };

    const changeCouponTabs = val => {
      currentCouponTabs.value = val
    }
    // 增值服务去商品详情页
    const goProductDetail = (group) => {
      console.log("defaultProductId", group);
      let productId = group.commodityList[group.selectedChildKey].productId
			let newWin = router.resolve({
				path: `/goods/detail`,
				query: {productId:productId}
			})
      window.open(newWin.href, '_blank')
      //window.open(`/goods/detail?productId=${productId}`, '_blank');
    }

    /*增值服务  start*/
    // 获取当前主商品增值服务
    const getIncrService = () => {
      let param = { productId: pre_params.data.productId };

      proxy
        .$post(
          'v3/promotion/front/increaseService/commodityList',
          param,
          'application/json'
        )
        .then(res => {
          if (res.state == 200) {
            incrServiceInfo.value = res.data;

            incrServiceInfo.value.forEach((group, idx) => {
              group.selectedChildKey = -1;
              group.parentId = idx + 'group'
              group.commodityList.forEach(item => {
                item.promotionType = group.promotionType
                item.promotionId = group.promotionId
                item.number = 1
                item.buyNum = 1
                item.activityPrice = item.productActivityPrice
              })
            })
          } else {
            if (res.msg) {
              ElMessage(res.msg)
            }
          }
        })
    }
    const showService = (currentMainProduct) => {
      currentMainProduct.value = currentMainProduct;

      resetIncrService();
      showServiceModal.value = true;// 打开增值服务弹框

    }
    // 重置已选增值服务
    const resetIncrService = () => {
      if (!incrementList.value) {
        return
      }

      incrementList.value.forEach(item => {
        item.number = 1;
        let convertedPrice = Number(item.price)
        if (!isNaN(convertedPrice) && typeof convertedPrice === 'number' && convertedPrice.toString() !== "NaN") {

          item.productActivityPrice = convertedPrice;
          item.productPrice = convertedPrice;
        }
        for (let i = 0; i < incrServiceInfo.value.length; i++) {
          const group = incrServiceInfo.value[i];
          const commodityIndex = group.commodityList.findIndex(
            (c) => c.productId === item.productId
          );
          if (commodityIndex >= 0) {
            item.groupId = group.parentId;
            group.selectedChildKey = commodityIndex;
            break;
          }
        }
      })

      console.log("增值服务弹窗展示---->", incrServiceInfo.value)

    }
    // 确认选择增值服务
    const confirmIncreaseService = () => {
      console.log("allData---->", allData.data)

      let promotionId = '';
      let promotionType = '';

      let originList = goods_data.data[0].productList[0].incrementList || [];
      if (originList[0]) {// 记录已选promotionId promotionType
        promotionId = originList[0].promotionId
        promotionType = originList[0].promotionType
      }

      let selectedList = [];
      incrServiceInfo.value.forEach(group => {
        if (group.hasOwnProperty('selectedChildKey') && group.selectedChildKey !== undefined) {
          const selectedItemIndex = group.selectedChildKey;
          if (group.commodityList && group.commodityList.length > selectedItemIndex) {
            if (selectedItemIndex >= 0) {
              selectedList.push({
                ...group.commodityList[selectedItemIndex],
                increaseGroupName: group.increaseGroupName, // 如果需要保留分组名称
                parentId: group.parentId, // 如果需要保留父ID等其他信息

              });
            }
          }
        }
      })
      incrementList.value = selectedList;
      console.log("已选增值服务---->", selectedList)
      showServiceModal.value = false;


      if (incrementList.value[0]) {

        promotionId = incrementList.value[0].promotionId
        promotionType = incrementList.value[0].promotionType
      }
      if (orderSn.value) { // 支付尾款
        changeBalancePaymentProduct(1, promotionId, promotionType);
      } else {
        confirmOrder(2); // 重新获取
      }


    }
    // 点击选择增值服务
    const chooseIncreaseService = (parentKey, key, item) => {
      console.log("parentKey-->", parentKey)
      console.log("key-->", key)
      console.log("item-->", item)

      let group = incrServiceInfo.value[parentKey];
      let selectedKey = group.selectedChildKey;
      if (selectedKey == key) { // 重复点击取消选中
        group.selectedChildKey = -1;

      } else {
        group.selectedChildKey = key;
      }

    }
    /*增值服务  end*/

    /*加价购  start*/
    const getCollocateProduct = () => {
      let param = { productId: pre_params.data.productId };

      proxy
        .$post(
          'v3/promotion/front/increasePriceShopping/commodityList',
          param,
          'application/json'
        )
        .then(res => {
          if (res.state == 200) {
            priceIncreasePurchaseInfo.value = res.data;
            priceIncreasePurchaseInfo.value.forEach(item => {
              item.selected = false;
              item.image = item.mainImageUrl;
              item.isAvailable = true;
              item.number = 1;
              item.buyNum = 1;
              item.price = item.productIncreasePrice;
              item.activityPrice = item.productIncreasePrice; // 活动价
            })
          } else {
            if (res.msg) {
              ElMessage(res.msg)
            }
          }
        })
    }
    const showMatchModal = (currentMainProduct) => {
      currentMainProduct.value = currentMainProduct;
      resetPriceIncreasePurchase();
      showMarkupModal.value = true;
    };
    // 重置加价购选择弹窗数据
    const resetPriceIncreasePurchase = () => {
      if (!priceIncreasePurchaseList.value) {
        return
      }

      priceIncreasePurchaseList.value.forEach(item => {
        item.activityPrice = item.price;
        item.number = item.buyNum;
        let productItem = priceIncreasePurchaseInfo.value.find(val => val.productId == item.productId);
        if (productItem) {
          productItem.selected = true;
          // 覆盖arr1中相同productId的数据
          Object.assign(productItem, item);
          productItem.number = item.buyNum;
          productItem.activityPrice = item.price;
          // productItem.productIncreasePrice = item.price;
          let convertedPrice = Number(item.price)
          if (!isNaN(convertedPrice) && typeof convertedPrice === 'number' && convertedPrice.toString() !== "NaN") {
            productItem.productIncreasePrice = convertedPrice;
          }
        }

      })
      console.log("----------------------------->", priceIncreasePurchaseList.value)

    }
    const choosePriceIncreasePurchase = (key) => {
      if (priceIncreasePurchaseInfo.value[key].selected) {
        priceIncreasePurchaseInfo.value[key].selected = false;
      } else {
        priceIncreasePurchaseInfo.value[key].selected = true;
      }
    }
    const modifiProductQuantities = (type, key) => {
      // number buyNum 
      let product = priceIncreasePurchaseInfo.value[key];
      console.log("----->", product)
      if (type == 'diminish') {// 减
        if (product.buyNum > 1) {
          product.buyNum = product.buyNum - 1;
          product.number = product.buyNum;
        }
      }
      if (type == 'plus') {
        // 
        if (product.buyNum < product.shoppingUpperLimit) {
          product.buyNum = product.buyNum + 1;
          product.number = product.buyNum;
        } else {
          ElMessage({
            message: '超过活动限制最大购买数量',
          });

        }
      }
    }
    const confirmPriceIncreasePurchase = () => {
      let promotionId = '';
      let promotionType = '';

      let originList = goods_data.data[0].productList[0].priceIncreasePurchaseList || [];
      if (originList[0]) {// 记录已选promotionId promotionType
        promotionId = originList[0].promotionId
        promotionType = originList[0].promotionType
      }

      console.log("priceIncreasePurchaseInfo---------->", priceIncreasePurchaseInfo.value)

      let newProductList = priceIncreasePurchaseInfo.value.filter(item => item.selected)
      console.log("已选--->", newProductList)

      priceIncreasePurchaseList.value = newProductList
      // return
      showMarkupModal.value = false;

      if (priceIncreasePurchaseList.value[0]) {
        promotionId = priceIncreasePurchaseList.value[0].promotionId
        promotionType = priceIncreasePurchaseList.value[0].promotionType
      }
      if (orderSn.value) {
        // 尾款
        changeBalancePaymentProduct(2, promotionId, promotionType)
      } else {
        confirmOrder(2);
      }
    }
    /*加价购  end*/
    /** 尾款修改 商品*/
    const changeBalancePaymentProduct = (type, promotionId, promotionType) => {
      /** type 1  修改 增值服务 2 修改 加价购 */
      /** promotionId  对应加价购或 增值服务的promotionId */

      if (isPreventClick.value) {
        return
      }
      isPreventClick.value = true
      let param = {};

      let url = 'v3/business/front/orderOperate/balanceProductChange';

      param = {
        orderSn: orderSn.value,
        promotionId: promotionId,
        promotionType: promotionType,
      }

      let productList = [];
      console.log(" incrementList.value--->", incrementList.value)
      console.log(" priceIncreasePurchaseList.value--->", priceIncreasePurchaseList.value)
      if (type == 1) {
        productList = incrementList.value.map(item => {
          return {
            buyNum: 1,
            productId: item.productId
          }
        })
      } else {
        productList = priceIncreasePurchaseList.value.map(item => {
          return {
            buyNum: item.buyNum,
            productId: item.productId
          }
        })
      }
      param.productList = productList;

      // return;
      proxy
        .$post(
          url,
          param,
          'application/json'
        )
        .then(res => {
          if (res.state == 200) {
            console.log("尾款订单修改商品------------->", res.data)
          } else {
            ElMessage(res.msg)
          }
          confirmOrder(2); // 重新获取
          isPreventClick.value = false
        })
    }
    /** 尾款删除商品 */
    const delProduct = (product) => {

      if (isPreventClick.value) {
        return
      }
      isPreventClick.value = true
      let param = {}
      let url = 'v3/business/front/orderOperate/balanceProductDel';

      param = {
        orderSn: orderSn.value,
        productId: product.productId,
        promotionId: product.promotionId,
        promotionType: product.promotionType,
      }

      proxy
        .$post(
          url,
          param,
          'application/json'
        )
        .then(res => {
          if (res.state == 200) {


            confirmOrder(2); // 重新获取
          } else {
            ElMessage(res.msg)
          }
          isPreventClick.value = false
        })
    }

    const mergeAndDeduplicate = (arr1, arr2) => {
      // 创建一个 Map 来存储 couponCode 作为唯一键
      const map = new Map();

      // 将两个数组合并为一个数组
      const combinedArray = [...arr1, ...arr2];

      // 遍历合并后的数组，并以 couponCode 为键存入 Map
      for (const item of combinedArray) {
        if (!map.has(item.couponCode)) {
          map.set(item.couponCode, item);
        }
      }

      // 将 Map 中的值转换为数组并返回
      return Array.from(map.values());
    }

    //用于切换地址，使用优惠券，获取信息，运费等
    const confirmOrder = type => {
      let param = {}
      param.source = type
      param.addressId = orderAddress.data.addressId

      if (platformCouponCode.value == L['不使用优惠券']) {
        delete param.platformCouponCode
      } else {
        param.platformCouponCode = platformCouponCode.value
      }

      let storeInfoList = []

      goods_data.data.map(item => {
        let storeitem = {}
        if (selCouponStore.store.storeId == item.storeId) {
          storeitem.remark = selCouponStore.store.remark
          storeitem.storeCouponCode =
            selCouponStore.couponCode == L['不使用优惠券']
              ? ''
              : selCouponStore.couponCode
          console.log("-------->", selCouponStore.couponCode)
          storeitem.storeId = item.storeId
        } else {
          storeitem.remark = item.remark
          storeitem.storeCouponCode =
            item.couponCode == L['不使用优惠券'] ? '' : item.couponCode
          storeitem.storeId = item.storeId
        }

        // 发票
        storeitem.invoiceId = select_invoice_info.data.invoiceId == 'a' || select_invoice_info.data.invoiceId == 'b' ? '' : select_invoice_info.data.invoiceId // 会员发票id
        storeitem.invoiceTitle = select_invoice_info.data.invoiceTitle // 发票抬头(非增值税发票传入)
        storeitem.taxCode = select_invoice_info.data.taxCode // 纳税人识别号(非增值税发票传入)
        storeitem.titleType = select_invoice_info.data.titleType // 抬头类型：1-个人；2-公司(非增值税发票传入)


        storeInfoList.push(storeitem)
      })

      if (usePoints.value) { // 使用积分
        param.integral = allData.data.integralCanUse;
      }



      param.storeInfoList = storeInfoList
      // console.log("详情 传来 数据pre_params.data------------>", pre_params.data)


      let url = 'v3/business/front/orderOperate/confirm';
      if (orderSn.value) {
        param.orderSn = orderSn.value;
        url = 'v3/business/front/orderOperate/balanceConfirm'
      }



      if (pre_params.data.ifcart == 'true') {
        //来自于购物车
        param.isCart = true
      } else {
        //立即购买
        param.productId = pre_params.data.productId
        param.number = pre_params.data.numbers
        param.isCart = false

        param.promotionId = pre_params.data.promotionId
        param.promotionType = pre_params.data.promotionType
        param.productPrice = pre_params.data.productPrice
      }

      if (!orderSn.value) { // 尾款订单不穿

        if (incrementList.value.length > 0) {
          if (pre_params.data.promotionType == 103) {//定金活动
            // 增值服务
            param.incrementList = incrementList.value.map(item => {

              return {
                ...item,
                productPrice: item.activityPrice ? item.activityPrice : item.productPrice // 活动价
              }
            })
          } else {
            param.incrementList = incrementList.value
          }
        }

        if (priceIncreasePurchaseList.value.length > 0) {

          if (pre_params.data.promotionType == 103) {//定金活动
            // 加价购
            param.priceIncreasePurchaseList = priceIncreasePurchaseList.value.map(item => {
              return {
                ...item,
                productPrice: item.activityPrice ? item.activityPrice : item.productPrice // 活动价
              }
            })
          } else {
            param.priceIncreasePurchaseList = priceIncreasePurchaseList.value
          }
        }


      }


      if (pre_params.data.promotionType == 404) { // A码购
        param.promotionCode = pre_params.data.promotionCode
      }


      proxy
        .$post(
          url,
          param,
          'application/json'
        )
        .then(res => {
          if (res.state == 200) {
            if (type == 1) {
              goods_data.data = res.data.storeGroupList
              goods_data.data.map((item, i) => {
                item.remark = ''
                let default_coupon = item.availableCouponList.filter(function (
                  coupon
                ) {
                  return coupon.checked == true
                })
                console.log("默认选中的coupon--->", default_coupon)
                if (default_coupon.length > 0) {
                  item.couponCode = default_coupon[0].couponCode
                  couponCode.value[i] = default_coupon[0].couponCode
                  selCouponStore.couponCode = default_coupon[0].couponCode
                } else {
                  item.couponCode = ''
                  couponCode.value[i] = ''
                }
              })
            } else {
              let tmpRes = res.data.storeGroupList
              goods_data.data.map((item, index) => {
                let default_coupon = tmpRes[index].availableCouponList.filter(
                  coupon => coupon.checked == true
                )
                if (default_coupon.length > 0) {
                  item.couponCode = default_coupon[0].couponCode
                  couponCode.value[index] = default_coupon[0].couponCode
                    ? default_coupon[0].couponCode
                    : L['不使用优惠券']
                } else {
                  item.couponCode = ''
                  couponCode.value[index] = L['不使用优惠券']
                }
                item.productList = tmpRes[index].productList;
                item.expressFee = tmpRes[index].expressFee
                item.totalDiscount = tmpRes[index].totalDiscount

                item.availableCouponList = tmpRes[index].availableCouponList;
                // item.availableCouponList = mergeAndDeduplicate(item.availableCouponList, tmpRes[index].availableCouponList); // 防止选中的优惠券数据变换位置 没有效果，下次在研究

                item.disabledCouponList = tmpRes[index].disabledCouponList
              })
            }
            allData.data = res.data


            if (allData.data.integral) {// 使用积分
              usePoints.value = true;
            }

            order_settle_info.totalAmount = res.data.totalAmount
            order_settle_info.platformCouponList = res.data.availableCouponList
            total.value = Math.ceil(
              order_settle_info.platformCouponList.length / 8
            )
            let default_plat_cou = order_settle_info.platformCouponList.filter(
              coupon => coupon.checked
            )
            let default_plat_coupons = JSON.parse(
              JSON.stringify(default_plat_cou)
            )
            if (default_plat_coupons.length) {
              default_plat_coupo.data = default_plat_coupons[0]
            }
            order_settle_info.totalDiscount = res.data.totalDiscount

            //处理平台优惠券
            let default_plat_coupon = order_settle_info.platformCouponList.filter(
              coupon => coupon.checked
            )
            if (default_plat_coupon.length > 0) {
              platformCouponCode.value = default_plat_coupon[0].couponCode
            } else {
              platformCouponCode.value = ''
            }

            if (type == 1) {
              virtual.isVG = allData.data.isVirtualGoods
              virtual.virtualPre = allData.data.reserveNameList.map(item => {
                item.reserveValue = ''
                return item
              })
            }
            if (allData.data.presellInfo) { // 定金订单
              incrementList.value = allData.data.storeGroupList[0].productList[0].incrementList || [];
              priceIncreasePurchaseList.value = allData.data.storeGroupList[0].productList[0].priceIncreasePurchaseList || [];
              resetIncrService();
              resetPriceIncreasePurchase();
            }
          } else {
            if (res.msg) {
              ElMessage(res.msg)
            }
          }
        })
    }
    //获取地址列表
    const getAddressList = () => {
      proxy
        .$get('v3/member/front/memberAddress/list')
        .then(res => {
          if (res.state == 200) {
            address_list.data = res.data.list
            if (res.data.list.length > 0 && !orderAddress.data.addressId) {
              let df_index = res.data.list.findIndex(function (item) {
                return item.isDefault == 1
              })
              if (df_index > -1) {
                orderAddress.data = res.data.list[df_index]
                current_address_index.value = df_index
              } else {
                orderAddress.data = res.data.list[0]
              }
              if (localStorage.getItem('addressId') && localStorage.getItem('addressId') != -1) {
                console.log("------- localStorage")
                let addressID = localStorage.getItem('addressId')
                let used_index = res.data.list.findIndex(
                  i => i.addressId == addressID
                )
                if (used_index > -1) {
                  current_address_index.value = used_index
                  orderAddress.data = res.data.list[used_index]
                } else {
                  current_address_index.value = -1
                }
              } else {
                // current_address_index.value = -1
              }
            }
            confirmOrder(1)
          } else {
            confirmOrder(2)
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }
    //切换地址
    const selectAddress = index => {
      current_address_index.value = index
    }
    //选择优惠券和积分
    const favourable = index => {
      favourable_show.value = index
    }
    //确认修改地址
    const confirmChangeAddress = index => {
      current_address_index.value = index
      orderAddress.data = address_list.data[current_address_index.value]
      show_select_address.value = false
      confirmOrder(2)
      localStorage.setItem('addressId', orderAddress.data.addressId)
    }
    //弹出地址选择框
    const changeAddress = () => {
      getAddressList()
      show_select_address.value = true
    }
    //鼠标移入
    const previous = ind => {
      if (ind == 0) {
        previous_page.value = true
      } else if (ind == 1) {
        next_page.value = true
      }
    }
    //鼠标移出
    const previou = ind => {
      if (ind == 0) {
        previous_page.value = false
      } else if (ind == 1) {
        next_page.value = false
      }
    }
    //上一页
    const upper = () => {
      if (pagesize.value > 1) {
        let end_one = rise.value
        end.value = end_one - 1
        rise.value = end_one - 8
        pagesize.value = pagesize.value - 1
      }
    }
    //下一页
    const lower = () => {
      if (pagesize.value < total.value) {
        let rose_one = end.value
        rise.value = rose_one + 1
        end.value = rose_one + 8
        pagesize.value = pagesize.value + 1
      }
    }
    //返回购物车
    const goCart = () => {
      router.go(-1)
    }


    /**
     * 发票相关 start
     */
    //弹出发票选择框
    const showInvoiceDialog = () => {

      // 将已选的覆盖回
      invoice_info.data = JSON.parse(JSON.stringify(select_invoice_info.data));


      edit_invoice_dialog.value = true

    }
    const closeInvoiceDialog = () => {
      console.log("关闭发票选择框")
      edit_invoice_dialog.value = false;
      console.log("form发票信息----<", invoice_info.data)
      console.log("form发票信息----<", JSON.stringify(invoice_info.data))
      console.log("已选发票信息----<", select_invoice_info.data)

      // 关闭窗口重置
      invoice_info.data = {
        invoiceId: 'a',//发票ID 增值税专用发票时传入
        invoiceTitle: '',// 发票抬头
        taxCode: '',//税号
        invoiceName: '电子发票-个人', // Name 
        titleType: 1, // 抬头类型 ：1-个人；2-公司(非增值税发票传入)};
      }
    }
    const confirmInvoice = () => {
      console.log("确认发票信息")

      invoiceForm.value.validate(valid => {
        if (valid) {
          console.log("发票信息----->", invoice_info.data)

          select_invoice_info.data = JSON.parse(JSON.stringify(invoice_info.data));

          // 关闭
          closeInvoiceDialog()
        } else {

          return false
        }
      })




      // select_invoice_info.data = invoice_info.data;


      console.log('发票信息--->', select_invoice_info.data)
    }

    //获取发票列表
    const getVoiceList = () => {
      proxy
        .$get('v3/member/front/memberInvoice/getInvoiceInfo')
        .then(res => {
          if (res.state == 200) {
            console.log("获取增值税发票-->", res.data)



            invoice_list.data = [
              {
                invoiceId: 'a',//发票ID 增值税专用发票时传入
                invoiceTitle: '',// 发票抬头
                taxCode: '',//纳税人识别号
                invoiceName: '电子发票-个人', // Name 
                titleType: 1, // 抬头类型 ：1-个人；2-公司(非增值税发票传入)
              },
              {
                invoiceId: 'b',//发票ID 增值税专用发票时传入
                invoiceTitle: '',// 发票抬头
                taxCode: '',//纳税人识别号
                invoiceName: '电子发票-公司', // Name 
                titleType: 2, // 抬头类型 ：1-个人；2-公司(非增值税发票传入)
              },
            ]
            if (res.data.invoiceId) {
              invoice_list.data.push({
                invoiceId: res.data.invoiceId + "",//发票ID 增值税专用发票时传入
                // taxCode: '',//纳税人识别号
                invoiceName: '增值税专用发票', // Name 
              })
            }

            console.log("invoice_list.data", invoice_list.data)
          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
          ElMessage("发票信息获取失败")
        })
    }




    watch(invoice_info.data, () => {
      // console.log("监视发票填写")
      // console.log("已选发票信息---->", invoice_info.data)
    })
    /**
     * 发票相关 end
     */

    // 确认定金弹窗
    const frontMoneyFun = (tag) => {
      console.log("------->", tag)
      if (tag == 1) {
        isAssentFrontMoney.value = true;
      } else {
        isAssentFrontMoney.value = false
      }

      frontMoneyFlag.value = false;
    }

    //确认订单前校验商品是否可购买
    const checkOrder = () => {
      if (isPreventClick.value) {
        return
      }
      isPreventClick.value = true

      if (allData.data.promotionType == 103 && !isAssentFrontMoney.value) {// 是否同意定金不退  // balanceConfirm返回promotionType是0 不用特殊处理只有定金会校验
        frontMoneyFlag.value = true;
        isPreventClick.value = false
        return
      }

      let param = {}
      if (pre_params.data.ifcart == 'true') {
        param.isCart = true
      } else {
        let {
          price,
          promotionId,
          promotionType
        } = goods_data.data[0].productList[0]

        param.isCart = false
        param.productId = pre_params.data.productId
        param.number = pre_params.data.numbers
        param.productPrice = price
        param.promotionId = promotionId
        param.promotionType = promotionType

        if (route.query.isAloneBuy) {
          delete param.promotionId
          delete param.promotionType
        }
      }


      if (allData.data.needInputSn) {
        if (!productSn.value) {
          ElMessage("请输入SN码")
          isPreventClick.value = true
          return
        }
      }



      let url = 'v3/business/front/orderOperate/check'
      if (orderSn.value) {
        url = 'v3/business/front/orderOperate/balanceConfirm'
        param.orderSn = orderSn.value
        param.source = 2
      }


      if (route.query.isAloneBuy) {
        param.isAloneBuy = true
      }

      reserveInfoList.value = []

      if (incrementList.value.length > 0) {
        if (pre_params.data.promotionType == 103) {//定金活动
          // 增值服务
          param.incrementList = incrementList.value.map(item => {

            return {
              ...item,
              productPrice: item.activityPrice ? item.activityPrice : item.productPrice // 活动价
            }
          })
        } else {
          param.incrementList = incrementList.value
        }
      }

      if (priceIncreasePurchaseList.value.length > 0) {

        if (pre_params.data.promotionType == 103) {//定金活动
          // 加价购
          param.priceIncreasePurchaseList = priceIncreasePurchaseList.value.map(item => {
            return {
              ...item,
              productPrice: item.activityPrice ? item.activityPrice : item.productPrice // 活动价
            }
          })
        } else {
          param.priceIncreasePurchaseList = priceIncreasePurchaseList.value
        }
      }


      if (pre_params.data.promotionType == 404) { // A码购
        param.promotionCode = pre_params.data.promotionCode
      }

      if (allData.data.needInputSn) { // 订单需要SN
        param.productSn = productSn.value
      }

      proxy
        .$post(
          url,
          param,
          'application/json'
        )
        .then(res => {
          if (res.state == 267) {
            let { state } = res.data
            no_good_info.data = res.data
            setTimeout(() => {
              isPreventClick.value = false
            }, 1000)
            if (
              state == 7 ||
              state == 4 ||
              state == 3 ||
              state == 2 ||
              state == 1 ||
              state == 6
            ) {
              out_stock_dialog.value = true
            } else if (state == 5) {
              proxy
                .$confirm(
                  L['商品促销信息发生变化，请返回后重新下单'],
                  L['商品促销信息发生变化'],
                  {
                    confirmButtonText: L['返回'],
                    type: 'warning'
                  }
                )
                .then(() => {
                  returnLastPage()
                })
            }
            if (state == 10) {
              ElMessage(res.data.stateValue)
            }
          } else if (res.state == 200) {
            goBuy()
          } else {
            ElMessage(res.msg)
            setTimeout(() => {
              isPreventClick.value = false
            }, 1000)
          }
        })
    }
    //返回上一页
    const returnLastPage = () => {
      out_stock_dialog.value = false
      router.go(-1)
    }
    //移除无货商品
    const clearFailureGoods = () => {
      proxy.$post('v3/business/front/cart/emptyInvalid').then(res => {
        if (res.state == 200) {
          out_stock_dialog.value = false
          confirmOrder(2)
          ElMessage.success(res.msg)
        } else {
          ElMessage(res.msg)
        }
      })
    }
    //跳转订单页
    const goBuy = () => {
      let param = {}
      param.source = 3
      param.orderFrom = 1
      if (virtual.isVG == 1) {
        param.addressId = orderAddress.data.addressId
      }
      param.platformCouponCode =
        platformCouponCode.value == L['不使用优惠券']
          ? ''
          : platformCouponCode.value
      let storeInfoList = []
      goods_data.data.map(item => {
        let storeitem = {}
        // 发票
        storeitem.invoiceId = select_invoice_info.data.invoiceId == 'a' || select_invoice_info.data.invoiceId == 'b' ? '' : select_invoice_info.data.invoiceId // 会员发票id
        storeitem.invoiceTitle = select_invoice_info.data.invoiceTitle // 发票抬头(非增值税发票传入)
        storeitem.taxCode = select_invoice_info.data.taxCode // 纳税人识别号(非增值税发票传入)
        storeitem.titleType = select_invoice_info.data.titleType // 抬头类型：1-个人；2-公司(非增值税发票传入)
        
        storeitem.remark = item.remark
        storeitem.storeCouponCode =
          item.couponCode == L['不使用优惠券'] ? '' : item.couponCode
        storeitem.storeId = item.storeId
        storeInfoList.push(storeitem)
      })
      param.storeInfoList = storeInfoList
      if (pre_params.data.ifcart == 'true') {
        //来自于购物车
        param.isCart = true
      } else {
        //立即购买
        param.productId = pre_params.data.productId
        param.number = pre_params.data.numbers
        param.isCart = false


        param.promotionId = pre_params.data.promotionId
        param.promotionType = pre_params.data.promotionType
        param.productPrice = pre_params.data.productPrice
      }

      if (chosenInt.value > 0) {
        param.integral = chosenInt.value
      }

      if (route.query.isAloneBuy) {
        param.isAloneBuy = true
      }


      if (incrementList.value.length > 0) {
        if (pre_params.data.promotionType == 103) {//定金活动
          // 增值服务
          param.incrementList = incrementList.value.map(item => {

            return {
              ...item,
              productPrice: item.activityPrice ? item.activityPrice : item.productPrice // 活动价
            }
          })
        } else {
          param.incrementList = incrementList.value
        }
      }

      if (priceIncreasePurchaseList.value.length > 0) {

        if (pre_params.data.promotionType == 103) {//定金活动
          // 加价购
          param.priceIncreasePurchaseList = priceIncreasePurchaseList.value.map(item => {
            return {
              ...item,
              productPrice: item.activityPrice ? item.activityPrice : item.productPrice // 活动价
            }
          })
        } else {
          param.priceIncreasePurchaseList = priceIncreasePurchaseList.value
        }
      }

      let url = 'v3/business/front/orderOperate/submit'
      if (orderSn.value) {// 尾款支付
        url = 'v3/business/front/orderOperate/balanceSubmit'
        param.orderSn = orderSn.value;
      }

      if (usePoints.value) {// 使用积分
        param.integral = allData.data.integral
      }


      if (pre_params.data.promotionType == 404) { // A码购
        param.promotionCode = pre_params.data.promotionCode
      }

      if (allData.data.needInputSn) { // 订单需要SN
        param.productSn = productSn.value
      }

      proxy
        .$post(
          url,
          param,
          'application/json'
        )
        .then(res => {
          if (res.state == 200) {
            let paySn = res.data.paySn
            proxy.$sldStatEvent({ behaviorType: 'buy', paySn })

            if (timer.value) {
              clearInterval(timer.value)
              timer.value = 0
            }
            timer.value = setInterval(() => {
              queryPayState(paySn)
            }, 300)
          } else {
            ElMessage(res.msg)

            setTimeout(() => {
              isPreventClick.value = false
            }, 1000)
          }
        })
    }
    // 定时查询是否可以支付
    const queryPayState = paySn => {
      getPayInfo(paySn)
    }
    //获取订单支付数据
    const getPayInfo = paySn => {
      proxy
        .$get('v3/business/front/orderPay/payInfo', {
          paySn: paySn,
          payFrom: 1
        })
        .then(res => {
          if (res.state == 200) {

            if (res.data.dealState == 3) {
              router.replace({
                path: 'Pay',
                query: {
                  paySn: paySn,
                  payFrom: 1,
                  ifcart: pre_params.data.ifcart
                }
              })
              //清除定时器
              if (timer.value) {
                clearInterval(timer.value)
                timer.value = null
              }
            } else if (res.data.dealState == 2) {
              ElMessage(res.data.failReason || L['提交订单失败，请稍后重试'])
              setTimeout(() => {
                isPreventClick.value = false
              }, 1000)
              //清除定时器
              if (timer.value) {
                clearInterval(timer.value)
                timer.value = null
              }
            }
          } else if (res.state == 267) {
            ElMessage.success(res.msg + L[',2s后自动跳转订单列表'])
            //清除定时器
            if (timer.value) {
              clearInterval(timer.value)
              timer.value = 0
            }
            setTimeout(() => {
              router.replace({
                path: '/member/order/list'
              })
            }, 2000)
          } else {
            setTimeout(() => {
              isPreventClick.value = false
            }, 1000)
            //清除定时器
            if (timer.value) {
              clearInterval(timer.value)
              timer.value = 0
            }
            ElMessage(res.msg)
          }
        })
    }
    onUnmounted(() => {
      if (timer.value) {
        clearInterval(timer.value)
        timer.value = 0
      }
    })
    //关闭弹窗
    const close = () => {
      addressVisibleFlag.value = false
    }
    //展开地址
    const exhibition = () => {
      exhibition_show.value = !exhibition_show.value
    }
    //弹出新建地址窗口
    const addAddress = () => {
      type.value = 'add'
      addressVisibleFlag.value = true
    }

    const refreshAddress = (addressInfo, addressId) => {
      orderAddress.data = addressInfo
      orderAddress.data.addressId = addressId
      getAddressList()
      localStorage.setItem('addressId', orderAddress.data.addressId)
    }
    // 删除地址
    const delAddress = addressId => {
      ElMessageBox.confirm(L['确定删除该地址?'], L['提示'], {
        confirmButtonText: L['确定'],
        cancelButtonText: L['取消'],
        type: 'warning'
      }).then(() => {
        proxy
          .$post('v3/member/front/memberAddress/del', {
            addressIds: addressId
          })
          .then(res => {
            if (res.state == 200) {
              ElMessage.success(res.msg)
              getAddressList()
            } else {
              ElMessage(res.msg)
            }
          })
      })
    }
    //编辑地址事件
    const editAddress = address => {
      addressInfo.data = address
      type.value = 'edit'
      addressVisibleFlag.value = true
    }

    const integralEng = () => {
      chosenInt.value = tmpInt.value
      if (chosenInt.value > 0) {
        confirmOrder(2)
      }
      showIntList.value = false
    }

    const integralAban = () => {
      tmpInt.value = 0
      if (chosenInt.value > 0) {
        chosenInt.value = 0
        confirmOrder(2)
      }
      showIntList.value = false
    }

    // 积分抵扣相关参数
    const getIntRule = () => {
      proxy
        .$get('v3/system/front/setting/getSettings', {
          names:
            'integral_conversion_ratio,integral_use_lowest_amount,integral_max_deduct_rate,integral_cash_out_is_enable'
        })
        .then(res => {
          if (res.state == 200) {
            intRuleList.value = res.data
          }
        })
    }

    const shIntRule = () => {
      showIntRule.value = true
    }

    //校验预留信息
    const checkPreMsg = (type, value, name, isRequired) => {
      switch (type) {
        case 1: {
          if (isRequired == 1) {
            return proxy.$checkPhone(value)
          } else {
            let regMobile = /(1[3-9]\d{9}$)/
            if (value && !regMobile.test(value)) {
              return `${L['请输入正确的']}${name}!`
            } else {
              return true
            }
          }

          break
        }
        case 2: {
          if (isRequired == 1) {
            return proxy.$checkIdentity(value)
          } else {
            if (value) {
              let reg18 = /^[1-9][0-9]{5}(18|19|20)[0-9]{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)[0-9]{3}([0-9]|(X|x))/
              let reg15 = /^[1-9][0-9]{5}[0-9]{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)[0-9]{2}[0-9]/
              if (reg18.test(value) || reg15.test(value)) {
                return true
              } else {
                return `${L['请输入正确的']}${name}`
              }
            } else {
              return true
            }
          }

          break
        }
        case 3: {
          let regNum = /[0-9]+(.[0-9]+)?/
          if (isRequired == 1) {
            if (!value) {
              return `${L['请输入']}${name}`
            } else if (!regNum.test(value)) {
              return `${L['请输入正确的']}${name}`
            } else {
              return true
            }
          } else {
            return true
          }
          break
        }
        case 4: {
          if (isRequired == 1) {
            if (!value) {
              return `${L['请输入']}${name}`
            } else if (type == 4) {
              return true
            }
          } else {
            return true
          }
          break
        }
        case 5: {
          if (isRequired == 1) {
            return proxy.$checkEmail(value)
          } else {
            let reg = /^([a-zA-Z0-9]+[-_.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[-_.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,6}$/
            if (value && !reg.test(value)) {
              return `${L['请输入正确的']}${name}!`
            } else {
              return true
            }
          }

          break
        }
      }
    }

    const goNext = () => {
      out_stock_dialog.value = false
      goBuy()
    }

    const showInt = () => {
      showIntList.value = true
      tmpInt.value = chosenInt.value
    }
    const calculateTotalPrice = (priceValue, buyNumValue) => {
      if (!priceValue || !buyNumValue) {
        return "0.00";
      }
      const total = parseFloat(priceValue) * buyNumValue;
      return isNaN(total) ? "0.00" : total.toFixed(2);
    };

    const formatNumberWithCommas = (num) => {
      if (num === undefined || num === null) {
        return '';
      }

      const numberValue = Number(num);
      if (isNaN(numberValue)) {
        return '';
      }

      // 使用 toLocaleString 方法来添加千位分隔符（逗号），并保留两位小数
      return numberValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };


    onMounted(() => {
      pre_params.data = route.query
      orderSn.value = route.query.orderSn || ''
      console.log("----------->", pre_params.data)
      if (pre_params.data.incrementList) { // 增值服务
        pre_params.data.incrementList = JSON.parse(pre_params.data.incrementList)
      }
      if (pre_params.data.priceIncreasePurchaseList) { // 加价购
        pre_params.data.priceIncreasePurchaseList = JSON.parse(pre_params.data.priceIncreasePurchaseList)
      }
      incrementList.value = pre_params.data.incrementList || [];
      priceIncreasePurchaseList.value = pre_params.data.priceIncreasePurchaseList || [];

      getAddressList()
      getIntRule()

      getVoiceList()

      if (pre_params.data.promotionType == 103) {
        // 获取增值服务
        getIncrService();
        getCollocateProduct();
      }
    })




    return {
      navlist,
      not_select,
      selected,
      addressInfo,
      show_change_address,
      edit_invoice_dialog,
      showInvoiceDialog,
      closeInvoiceDialog,
      invoice_selected,
      confirmInvoice,



      out_stock_dialog,
      orderAddress,
      changeAddress,
      show_select_address,
      address_list,
      current_address_index,
      selectAddress,
      confirmChangeAddress,
      goods_data,
      pre_params,
      invoice_info,




      invoice_list,
      select_invoice_info,


      order_settle_info,
      confirmOrder,
      checkOrder,
      goBuy,
      returnLastPage,
      clearFailureGoods,
      no_good_info,
      addressVisibleFlag,
      close,
      type,
      refreshAddress,
      addAddress,
      editAddress,
      delAddress,
      couponCode,
      platformCouponCode,
      configInfo,
      rules,
      changeCoupon,
      intRuleList,
      allData,
      showIntList,
      chosenInt,
      integralEng,
      integralAban,
      showIntRule,
      shIntRule,
      L,
      tmpInt,

      virtual,
      preMsgErr,
      goNext,
      invoiceCheckState,
      exhibition,
      exhibition_show,
      favourable_show,
      favourable,
      default_plat_coupo,
      previous,
      previou,
      previous_page,
      next_page,
      upper,
      lower,
      rise,
      end,
      total,
      pagesize,
      goCart,
      showInt,
      discountPlaform,
      calculateTotalPrice,
      couponText,
      changeCouponTabs,
      currentCouponTabs,
      formatNumberWithCommas,
      showServiceModal,
      incrServiceInfo,
      showService,
      chooseIncreaseService,
      confirmIncreaseService,
      showMarkupModal,
      showMatchModal,
      priceIncreasePurchaseInfo,
      choosePriceIncreasePurchase,
      modifiProductQuantities,
      confirmPriceIncreasePurchase,
      delProduct,
      usePoints,
      changePoints,
      frontMoneyFlag,
      frontMoneyFun,
      productSn,
      redeemCoupons,


      invoiceForm,

    }


  },
  beforeRouteEnter (to, from, next) {
    // ...
    if (from.name == 'Login') {
      next('/index')
    } else {
      next()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/confirmOrder.scss";
</style>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.add_voice_btn2 {
  margin: -30px 114px 10px !important;
}

.out_store_width {
  width: 480px !important;
}

.select_address_width {
  width: 500px !important;
}

.el-dialog__body {
  padding-top: 10px;
}

.el-input__inner {
  font-size: 12px;
  line-height: 1px !important;
  /**
		* 解决el-input设置类型为number时，中文输入法光标上移问题
		**/
}

.confirm_order_container .input_email .el-input__inner {
  padding-right: 80px;
}

/* .el-select .el-input__inner:focus { */
/* border-color: var(--color_main); */
/* } */

/* .el-select .el-input.is-focus .el-input__inner { */
/* border-color: var(--color_main); */
/* } */

.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  /* border-color: var(--color_main); */
  outline: 0;
}

.integral_dialog .el-dialog__body {
  padding: 0;
}

#pre_tag_input {
  height: 30px;
  width: 320px;
}

.preMsgErr {
  color: var(--color_main);
  margin-left: 13px;
}
</style>
